import { render, staticRenderFns } from "./clinic-select.vue?vue&type=template&id=181b127c&"
import script from "./clinic-select.vue?vue&type=script&lang=js&"
export * from "./clinic-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports